import DOMPurify from 'dompurify';

export default function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ADD_ATTR: ['target'],
    ALLOW_UNKNOWN_PROTOCOLS: true,
  });
}
